/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */

import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postVerifyQrCodeWhithToken } from "../../services/mfaServices";
import { handleErrors } from "../../services/handleErrors";

function VerifyMfaCodeModal({ toggle, isOpen, button, handleNextModal, isVerified, isRemplacing }) {
  const [incorrectToken, setIncorrectToken] = useState(false);

  const formik = useFormik({
    initialValues: {
      token: "",
    },
    onSubmit: async (values) => {
      const { token } = values;
      try {
        postVerifyQrCodeWhithToken(token.replace(/\s/g, "")).then((res) => {
          if (res.success === true) {
            toast.success("Código de autenticación verificado");
            isVerified();
            handleNextModal();
            toggle();
          } else if (res.success === false) {
            toast.error("código incorrecto");
            setIncorrectToken(true);
          }
        });
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      token: Yup.string().required("Este campo es requerido."),
    }),
  });

  const tokenError = () => {
    let error = "";
    if (incorrectToken) {
      error = "El código de autenticación no coincide";
    }
    if (formik.errors.token) {
      error = formik.errors.token;
    }
    return error;
  };
  const messageError = tokenError();

  return (
    <div>
      {button ? (
        <Button color="primary" onClick={toggle} className="btn btn-primary" disabled={isRemplacing}>
          {button}
        </Button>
      ) : (
        ""
      )}
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <form className="theme-form" onSubmit={formik.handleSubmit}>
          <ModalHeader className="border-0 pb-0" toggle={toggle} />
          <ModalBody className="pt-0 pb-0">
            <>
              <p className="badge-pills p-4 w-100">Introducir el código de tu app de autenticación</p>
              <div className="p-4 w-100">
                <p className="form-label mb-1">Código de autenticación</p>
                <div className="form-group">
                  <input
                    className={formik.errors.email && formik.touched.email ? "form-control error-field" : "form-control"}
                    name="token"
                    placeholder="Ingresa tu código"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.token}
                  />
                  {messageError && formik.touched.token && <div className="input-feedback">{messageError}</div>}
                </div>
              </div>
            </>
          </ModalBody>
          <ModalFooter className="border-0 pt-0">
            <Button className="mr-2" color="btn-secondary" onClick={toggle}>
              Cancelar
            </Button>
            <Button color="btn btn-primary" disabled={formik.isSubmitting} type="submit">
              Verificar
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
}

export default VerifyMfaCodeModal;
